<template>
  <div class="box6">
    <div class="blockone" ref="block"></div>
    <pageTitle
      title="聚焦培养新媒体运营+社群运营+<br/>短视频运营+电商直播运营"
      text="定位清晰，内容深入，紧跟市场，全新升级至V11.1版"
      titleColor="#1A0400"
      titColor="#665552"
    />
    <div class="subTitle"></div>
    <div class="content">
      <div
        class="subject-box"
        ref="item"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="subject" @click="changeCur(index)">
          <div class="stage">{{ item.stage }}</div>
          <div class="title">{{ item.nav }}</div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
          </div>
        </div>

        <div
          class="course-content"
          :class="{ 'show-answer': cur == index && showAnswer }"
        >
          <div class="line"></div>

          <div class="title-icon">主讲内容</div>

          <div class="targe">
            <p v-for="j in item.text" :key="j + 'a'" v-html="j"></p>
          </div>

          <div class="title-icon">涉及工具</div>

          <div class="targe">
            <div class="item" v-for="i in item.tool" :key="i.name + 'b'">
              <img
                v-if="i.imgName"
                ref="img"
                :src="
                  require(`../../../assets/coursePage/newMedia/box6/tool/${i.imgName}.png`)
                "
                alt=""
              />
              <h4 ref="text" v-if="i.imgName">{{ i.name }}</h4>
            </div>
          </div>

          <div class="title-icon special">能力提升</div>
          <div class="skillImg">
            <img
              :src="
                require(`../../../assets/coursePage/newMedia/box6/stageSection0${
                  index + 1
                }.png`)
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="btn" @click="openDetail">了解更多课程详情</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list: [
        {
          nav: "新媒体运营",
          stage: "阶段一",
          tool: [
            {
              name: "Photoshop",
              imgName: "Photoshop",
            },
            {
              name: "Xmind",
              imgName: "X-mind",
            },
            {
              name: "Word",
              imgName: "Word",
            },
            {
              name: "Excel",
              imgName: "Excel",
            },
            {
              name: "PPT",
              imgName: "PPT",
            },
            {
              name: "可画",
              imgName: "canva",
            },
            {
              name: "头条号",
              imgName: "toutiao",
            },
            {
              name: "微博",
              imgName: "weibo",
            },
            {
              name: "公众号平台",
              imgName: "gongzhonghao",
            },
            {
              name: "新榜",
              imgName: "xinbang",
            },
            {
              name: "秀米编辑器",
              imgName: "xiumi",
            },
            {
              name: "问卷星",
              imgName: "wenjuanxing",
            },
            { name: "问卷星1" },
            { name: "问卷星2" },
            { name: "问卷星3" },
          ],

          text: [
            "第一章 市场调研与策划定位 ",
            "第二章 爆款内容选题生产流程 ",
            "第三章 小白如何产出10W+爆文<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>优化</i>",
            "第四章 软文及图文精美排版 ",
            "第五章 玩转自媒体平台<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>优化</i>",
            "第六章 新媒体内容互动技巧 ",
          ],

          boxImg: "stageSection01",
        },

        {
          nav: "社群运营",
          stage: "阶段二",
          tool: [
            {
              name: "小裂变",
              imgName: "xiaoliebiao",
            },
            {
              name: "WeTool",
              imgName: "WeTool",
            },
            {
              name: "ISOOC模型",
              imgName: "ISOOC",
            },
            {
              name: "有机云",
              imgName: "youji",
            },
            {
              name: "群活码",
              imgName: "qunhuoma",
            },
            {
              name: "蜂鸟裂变",
              imgName: "fengniao",
            },
            {
              name: "小打卡",
              imgName: "xiaodaka",
            },
            {
              name: "微信小号",
              imgName: "weixin",
            },
            {
              name: "企业微信",
              imgName: "qiye",
            },
            {
              name: "ProcessOn",
              imgName: "Processon",
            },
            {
              name: "可画",
              imgName: "canva",
            },
          ],
          text: [
            "第一章 社群搭建理论基础",
            "第二章 社群运营全流程",
            "第三章 社群运营行业案例拆解",
            "第四章 社群活动执行",
          ],

          boxImg: "stageSection02",
        },
        {
          nav: "短视频运营",
          stage: "阶段三",
          tool: [
            {
              name: "Premiere",
              imgName: "Premiere",
            },
            {
              name: "After Effects",
              imgName: "ae",
            },
            {
              name: "有米有数",
              imgName: "youmeiyou",
            },
            {
              name: "蝉妈妈",
              imgName: "mama",
            },
            {
              name: "剪映APP",
              imgName: "jianying",
            },
            {
              name: "格式工厂",
              imgName: "geshihua",
            },
            {
              name: "巨量星图",
              imgName: "xingtu",
            },
            {
              name: "巨量千川",
              imgName: "qianchuan",
            },
            {
              name: "抖店",
              imgName: "doudian",
            },
            {
              name: "Dou+",
              imgName: "dou",
            },
            {
              name: "视频号",
              imgName: "shipinzhibo",
            },
            {
              name: "飞瓜数据",
              imgName: "feigua",
            },
            {
              name: "小红书",
              imgName: "hongshu",
            },
            {
              name: "巨量算数",
              imgName: "suanshu",
            },
            {
              name: "巨量创意",
              imgName: "juliang",
            },
            {
              name: "快手",
              imgName: "kuaishou",
            },
            {
              name: "快手直播伴侣",
              imgName: "zhibo",
            },
            {
              name: "视频号小店",
              imgName: "xiaohao",
            },
            {
              name: "快手直播伴侣1",
            },
            {
              name: "视频号小店1",
            },
          ],

          text: [
            " 第一章 短视频基础",
            "第二章 小白也能学会拍摄技巧",
            "第三章 掌握专业剪辑师剪辑技巧，轻松应对短视频制作",
            "第四章 掌握短视频特效制作软件AE",
            "第五章 短视频的DOU+付费推广",
            "第六章 千川付费推广<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>新增</i>",
            "第七章 抖音短视频免费和跨平台推广",
            "第八章 快手&小红书运营<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>优化</i>",
            "第九章 腾讯视频号运营<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>优化</i>",
            "第十章 抖音电商变现运营 ",
            "第十一章 蓝V企业号",
            "第十二章 抖音短视频的数据运营",
            "第十三章 模拟企业账号方案撰写",
          ],

          boxImg: "stageSection03",
        },
        {
          nav: "短视频电商直播",
          stage: "阶段四",
          tool: [
            {
              name: "OBS studio",
              imgName: "OBSstudio",
            },
            {
              name: "哔哩哔哩",
              imgName: "bilibili",
            },
            {
              name: "抖音直播伴侣",
              imgName: "douyin",
            },
            {
              name: "视频直播号",
              imgName: "shipinzhibo",
            },
            {
              name: "义乌购",
              imgName: "yiwu",
            },
            {
              name: "阿里巴巴",
              imgName: "alibb",
            },
            {
              name: "巨量千川",
              imgName: "qianchuan",
            },
            {
              name: "小店随心推",
              imgName: "suixintui",
            },
            {
              name: "抖音橱窗",
              imgName: "gouwuche",
            },
            {
              name: "淘宝联盟",
              imgName: "taobaolianmeng",
            },
            {
              name: "京东联盟",
              imgName: "lianmeng",
            },
          ],

          text: [
            "第一章 电商直播课人篇",
            "第二章 货的选品定价和上架",
            "第三章 直播间的场景的策划和搭建",
            "第四章 直播逼单话术玩法+直播脚本<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>优化</i>",
            "第五章 直播电商数据<i style='display:inline-block;margin-left:0.099667rem;font-size: 0.24rem;color: #ff5533;font-style:normal;width: 0.72rem;height: 0.313333rem;text-align:center;line-height:0.313333rem;border-radius: 0.076667rem;border: solid 1px #ff5533;'>优化</i>",
          ],

          boxImg: "stageSection04",
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  mounted() {
    this.$refs.text.forEach((item) => {
      let moveWidth = (item.clientWidth - this.$refs.img[0].clientWidth) / 2;
      item.style.left = -moveWidth + "px";
    });
  },
  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
       this.mai("新媒体+短视频-就业课","了解更多课程详情",0,null)
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
        this.cur = index;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 0px 0px 88px 0;
  width: 100%;
  background: url("../../../assets/coursePage/newMedia/box6/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .blockone {
    height: 80px;
  }
  .subTitle {
    background: url("../../../assets/coursePage/newMedia/box6/subtitle.png");
    width: 728px;
    background-size: cover;
    height: 112px;
    margin: 48px auto 20px;
  }

  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 690px;
    height: 96px;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    line-height: 96px;
    text-align: center;

    text-shadow: 2px 6px 0px #207dff;
    background: linear-gradient(180deg, #ff8932 0%, #ff2a00 100%);
    box-shadow: 0px 10px 20px 0px #ffd4cc, 0px 4px 16px 0px #fecebf;
    border-radius: 48px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;

    text-shadow: 0px 6px 5px rgba(234, 49, 12, 0.77);
  }

  .title-top {
    position: relative;
    margin: 60px auto 0;
    margin-bottom: 40px;
    padding-left: 50px;
    width: 690px;
    height: 100px;
    background: url("../../../assets/coursePage/pythonData/box9/title.png")
      no-repeat;
    background-size: cover;
    border-radius: 20px;
    box-shadow: 0px 6px 29px 0px rgba(135, 212, 240, 0.98);
    box-sizing: border-box;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    font-weight: normal;
    line-height: 100px;
    letter-spacing: 0px;
    color: #ffffff;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 100px;
      letter-spacing: 0px;
      color: #ffffff;
      text-shadow: 6px 16px 0px #3f6ae4;
    }
    &::after {
      position: absolute;
      right: 0px;
      bottom: 0px;
      content: "";
      width: 180px;
      height: 126px;
      background: url("../../../assets/coursePage/pythonData/box9/icon.png")
        no-repeat;
      background-size: cover;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0px 8px 29px 0px rgba(255, 172, 131, 0.25);
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 28px 32px;

    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    .stage {
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: bold;
      line-height: 96px;
      letter-spacing: 0px;
      white-space: nowrap;
      color: rgba(255, 109, 80, 1);
    }

    .title {
      margin-left: 24px;
      margin-right: 20px;
      font-family: PingFangSC-Medium;
      font-size: 28px;
      font-weight: bold;
      font-stretch: normal;

      letter-spacing: 0px;
      color: #3a2c29;
      width: 496px;
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 32px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;

    max-height: 0;
    opacity: 0;
    border-radius: 0px 0px 16px 16px;
    transition: 0.3s ease all;

    overflow: hidden;
    z-index: 3;

    .line {
      margin: 0 auto;
      margin-bottom: 32px;
      width: 622px;
      height: 1px;
      background: #f2f3f5;
    }
  }

  .show-answer {
    padding: 0px 32px;
    // padding-bottom: 40px;
    // display: block;
    max-height: 2500px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;

    img {
      margin-right: 16px;
      width: 22px;
      height: 21px;
    }

    .icon1 {
      width: 181px;
      height: 22px;
    }
  }

  .main-content {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 0px 16px;
      height: 44px;
      background: rgba(179, 227, 254, 0.32);
      border-radius: 8px;

      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }

  .targe {
    margin-bottom: 48px;

    font-family: PingFang SC;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    justify-content: space-between;
    p {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
    }
    display: flex;
    flex-wrap: wrap;

    align-content: flex-start;
    .item {
      position: relative;
      margin-right: 55px;
      margin-bottom: 56px;
      font-size: 22px;
      width: 74px;
      img {
        width: 74px;
        height: 74px;
      }
      h4 {
        position: absolute;
        width: max-content;

        text-align: center;
      }
    }
    .item:nth-child(5n) {
      margin-right: 0;
    }
  }
  .skillImg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #fffbfa;
    border-radius: 14px;
    margin-bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5%;
    box-sizing: border-box;
    img {
      width: 90%;
      height: 90%;
    }
  }
}
</style>
